import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Link from 'next/link';
import Card from 'components/Card';
import { templatesCardData } from 'sections/Resources/FreightTemplates/data';
import { TemplateCard } from 'sections/Resources/FreightTemplates/types';
import styles from 'sections/Resources/FreightTemplates/components/SectionTemplates/SectionTemplates.module.scss';

const cn = classNames.bind(styles);

const SectionTemplates = (): ReactElement => {
  const cards = templatesCardData.map((card: TemplateCard) => {
    const generateHeading = () => {
      if (card.url) {
        return (
          <>
            <Link
              className={cn('card__heading-url')}
              href={card.url as Route}
            >
              {card.heading}
            </Link>
          </>
        );
      } else {
        return (
          <span>{card.heading}</span>
        );
      }
    };
    
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-box')}>
            <img
              className={cn('card__icon')}
              src={`/images/pages/Resources/FreightTemplates/${card.iconName}`}
              alt='file'
            />
            <h4 className={cn('card__heading')}>
              {generateHeading()}
            </h4>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <a
              className={cn('card__button')}
              href={`/download/Resources/FreightTemplates/${card.fileName}.docx`}
            >
              Download (Word)
            </a>
            <a
              className={cn('card__button')}
              href={`/download/Resources/FreightTemplates/${card.fileName}.pdf`}
              target='_blank'
            >
              Download (PDF)
            </a>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('templates')} id='templates'>
      <div className={cn('container')}>

        <h2 className={cn('templates__heading')}>
          Available Templates
        </h2>

        <div className={cn('templates__cards')}>
          {cards}
        </div>
      </div>

    </section>
  );
};

export default SectionTemplates;